import React, { useState } from 'react';
import { AppBar, Toolbar, Box, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { connect, useDispatch, useSelector } from 'react-redux';
import { openDrawer } from 'store/actions/Menu';

import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import capitalize from 'utils/capitalize';
import { InvitationsButton } from './InvitationsButton';
import { ResiUserMenu } from './ResiUserMenu';
import { Bell } from 'lucide-react';
import { NotificationsDrawer } from './NotificationsDrawer';

import {
    clearNotificationsBadge,
    markNotificationsReadRequest
} from 'store/actions/Notifications';

const DRAWER_WIDTH = 260;
const MINI_DRAWER_WIDTH = 60;

function TopNavigationComponent({ drawerOpen, openDrawer, userData, isHorizontal }) {
    const theme = useTheme();
    const dispatch = useDispatch();
    const downLG = useMediaQuery(theme.breakpoints.down('lg'));
    const residentName = userData?.first_name || 'Resident';
    const leftOffset = downLG ? 0 : drawerOpen ? DRAWER_WIDTH : MINI_DRAWER_WIDTH;

    const { items = [], badge } = useSelector(state => state.notifications || {});
    const [notificationsDrawerOpen, setNotificationsDrawerOpen] = useState(false);

    const handleNotificationsDrawerToggle = () => {
        setNotificationsDrawerOpen(prev => {
            const nextOpen = !prev;

            if (nextOpen) {
                dispatch(clearNotificationsBadge());
                dispatch(markNotificationsReadRequest());
            }

            return nextOpen;
        });
    };
    return (
        <>
            <AppBar
                position="fixed"
                elevation={0}
                color="inherit"
                sx={{
                    bgcolor: '#ffffff',
                    borderBottom: '1px solid #f0f0f0',
                    boxShadow: 'none',
                    zIndex: 1200,
                    left: { lg: `${leftOffset}px` },
                    width: {
                        lg: `calc(100% - ${leftOffset}px)`
                    }
                }}
            >
                <Toolbar
                    sx={{
                        minHeight: '64px !important',
                        px: { xs: 2, sm: 2 },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        position: 'relative'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            minWidth: 0,
                            flexShrink: 0
                        }}
                    >
                        {!isHorizontal ? (
                            <IconButton
                                onClick={() => openDrawer(!drawerOpen)}
                                sx={{
                                    bgcolor: '#efefef',
                                    borderRadius: '6px',
                                    width: 32,
                                    height: 32,
                                    '&:hover': {
                                        bgcolor: '#e0e0e0'
                                    }
                                }}
                            >
                                {!drawerOpen ? (
                                    <MenuUnfoldOutlined />
                                ) : (
                                    <MenuFoldOutlined />
                                )}
                            </IconButton>
                        ) : null}

                        <Typography
                            sx={{
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                                fontSize: '16px',
                                color: '#212322',
                                ml: 2,
                                display: { xs: 'none', sm: 'block' }
                            }}
                        >
                            Hello, {capitalize(residentName)}
                        </Typography>
                    </Box>

                    <Box sx={{ width: 32, flexShrink: 0 }} />
                    {/* Right Side - Invitations + Notifications */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '22px' }}>
                        <InvitationsButton />

                        {/* Notifications */}
                        <IconButton
                            onClick={handleNotificationsDrawerToggle}
                            sx={{
                                bgcolor: '#f8f8f8',
                                border: '0.762px solid #dedede',
                                borderRadius: '999px',
                                width: '32px',
                                height: '32px',
                                minWidth: '32px',
                                p: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                                '&:hover': {
                                    bgcolor: '#efefef'
                                }
                            }}
                        >
                            <Bell size={17.455} color="#212322" />
                            {badge !== '0' && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '-5px',
                                        left: '-2px',
                                        width: '14px',
                                        height: '14px',
                                        bgcolor: '#33C78F',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontFamily: 'Poppins, sans-serif',
                                            fontWeight: 600,
                                            fontSize: '8.5px',
                                            lineHeight: '6.857px',
                                            color: 'white'
                                        }}
                                    >
                                        {badge}
                                    </Typography>
                                </Box>
                            )}
                        </IconButton>

                        <ResiUserMenu />
                    </Box>
                </Toolbar>
            </AppBar>
            <NotificationsDrawer
                items={items}
                open={notificationsDrawerOpen}
                onClose={() => setNotificationsDrawerOpen(false)}
            />
        </>
    );
}

const mapStateToProps = ({ menu, user }) => ({
    drawerOpen: menu.drawerOpen,
    userData: user.userData
});

export const TopNavigation = connect(mapStateToProps, { openDrawer })(
    TopNavigationComponent
);
export default TopNavigation;
